module.exports = __webpack_public_path__ + "aab2816988f9d9cd3407a570a2af297d.png";